import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Title from '../dev/Title'
import { defineMessages } from 'react-intl';

const { REACT_APP_URI = '/' } = process.env
class RegisterActive extends Component {
    state = {
    }
    componentDidMount = () => {
        const { match: { params: { id } } } = this.props
        fetch(`${REACT_APP_URI}/accounts/activate/${id}/`, { credentials: 'include', })
            .then(res => { 
                if (res.status === 200) { setTimeout(() => { this.props.history.push('/') }, 1000)}
                else throw res
            })
            .then(() => setTimeout(() => { this.props.dispatch({ type: 'toggleUserField', condition: 'signIn' }) }, 1000))
    }
    render() {
        return (
            <Container>
                <Title>{defineMessages.user_active_verifying}</Title>
            </Container> 
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User
    }
}
export default withRouter(connect(mapStateToProps)(RegisterActive));
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px;
    height: 350px;
`



// WEBPACK FOOTER //
// ./src/User/UserActive/RegisterActive.js